import { css } from '@emotion/react';

export const defaultStyles = css`
    .favorite-button {
        border: 1px solid #000;
        background: #fff;
        font-weight: bold;
        padding: 0 5px;
    }

    .favorite-button i {
        margin-right: 5px;
    }
`;

export const themeStyles = css`
    button {
        background-color: var(--buttonComponent-primaryBackgroundColor);
        border-color: var(--buttonComponent-primaryBorderColor);
        border-style: var(--buttonComponent-borderStyle);
        border-width: var(--buttonComponent-borderWidth);
        font-size: var(--buttonComponent-fontSize);
        font-weight: var(--buttonComponent-fontWeight);
        font-family: var(--buttonComponent-fontFamily);
        line-height: var(--buttonComponent-lineHeight);
        padding: var(--buttonComponent-padding);
        border-radius: var(--buttonComponent-borderRadius);
        color: var(--buttonComponent-textColor);
    }

    button.disabled {
        background-color: var(--buttonComponent-disabledBackgroundColor);
        border-color: var(--buttonComponent-disabledBorderColor);
    }

    button.delete {
        background-color: var(--buttonComponent-deleteBackGroundColor);
        border-color: var(--buttonComponent-deleteBorderColor);
    }

    button.success {
        background-color: var(--buttonComponent-okBackGroundColor);
        border-color: var(--buttonComponent-okBorderColor);
    }
`;
